import { render, staticRenderFns } from "./delivery_detail.vue?vue&type=template&id=295e2227&scoped=true"
import script from "./delivery_detail.vue?vue&type=script&lang=js"
export * from "./delivery_detail.vue?vue&type=script&lang=js"
import style0 from "./delivery_detail.vue?vue&type=style&index=0&id=295e2227&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e2227",
  null
  
)

export default component.exports